import { App } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import SurveyViewForm from "@/views/survey-views/components/SurveyViewForm";
import { useSurveyViewForm } from "@/views/survey-views/hooks/useSurveyViewForm";
import { useCreateSurveyViewMutation } from "@/redux/service";
import { SurveyViewFormValues } from "@/views/survey-views/types";
import { SurveyViewColorScheme } from "@/redux/survey-views/types";

const SurveyViewCreate = () => {
  const { notification } = App.useApp();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { form } = useSurveyViewForm();
  const [createSurveyView] = useCreateSurveyViewMutation();

  const handleSubmit = form.handleSubmit(
    async (values: SurveyViewFormValues) => {
      const data = {
        version: 2,
        ...values,
        config: {
          ...values.config,
          colorScheme: values.config.grayScale
            ? SurveyViewColorScheme.GRAY_SCALE
            : SurveyViewColorScheme.DEFAULT,
        },
        answers: values.answers.map((answer) => ({
          ...answer,
          blocks: answer.blocks.map((block) => ({
            id: block.id,
          })),
        })),
      };
      const response = await createSurveyView(data).unwrap();
      notification.success({
        message: t("surveyViewCreated"),
      });
      navigate(`/reports/views/${response.id}`);
      form.reset();
    },
  );

  return <SurveyViewForm form={form} handleSubmit={handleSubmit} />;
};

export default SurveyViewCreate;
